<template>
  <section class="intro-container">
    <div class="app-logo">
      <span class="app-text">
        Johku App
      </span>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

